import styled from 'styled-components';

export const text=styled.div`
    font-weight:500 ;
    span{
        font-weight:800 ;
    }
`;
